import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/scroll";

export default function Contact() {
  return (
    <section id="contact" className="relative overflow-hidden py-28 lg:py-40">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="orb absolute -bottom-40 left-1/4 h-[30rem] w-[30rem] rounded-full bg-[#FF3B30] opacity-[0.1] blur-[150px]" />
        <div className="orb-2 absolute -top-20 right-0 h-[26rem] w-[26rem] rounded-full bg-[#00F2FE] opacity-[0.06] blur-[130px]" />
      </div>

      <div className="wrap relative grid items-center gap-16 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6 }}
            className="eyebrow mono-label text-[11px] text-[#FF3B30]"
          >
            Got a video in mind?
          </motion.p>

          <motion.h2
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            data-testid="contact-section-cta"
            className="mt-6 font-display font-black uppercase leading-[0.88] tracking-tight"
          >
            <span className="block text-[clamp(2.6rem,7vw,5.5rem)]">Let&apos;s make your</span>
            <span className="block text-[clamp(2.6rem,7vw,5.5rem)]">next video</span>
            <span className="text-gradient block text-[clamp(2.6rem,7vw,5.5rem)]">unmissable.</span>
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="mt-12 flex flex-wrap items-center gap-4"
          >
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-button" className="btn-primary">
              <MessageCircle className="h-5 w-5" />
              Message me on WhatsApp
            </a>
            <a href="tel:+918604796110" data-testid="contact-phone-button" className="btn-ghost">
              <Phone className="h-4 w-4" />
              8604796110
            </a>
            <span className="mono-label rounded-full border border-white/10 px-4 py-2 text-[9px] text-zinc-500">
              Message only — WhatsApp is fastest
            </span>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="relative mx-auto w-full max-w-xs lg:col-span-4"
          data-testid="contact-portrait"
        >
          <div className="rounded-[28px] bg-gradient-to-br from-[#00F2FE]/60 via-[#8E2DE2]/60 to-[#FF3B30]/60 p-[1.5px]">
            <div className="overflow-hidden rounded-[26px] bg-[#0E0E12]">
              <img
                src="/media/ayan-suit.png"
                alt="Ayan Jafri"
                loading="lazy"
                className="aspect-[4/5] w-full object-cover"
              />
            </div>
          </div>
          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border border-white/10 bg-black/70 px-5 py-2.5 backdrop-blur-xl">
            <span className="mono-label text-[10px] text-white">Ayan Jafri</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
